export default "__VITE_ASSET__CqUYwA1F__"